const INITIAL_STATE = {
  loginData: {},
  loginCallbackData: {},
  errors: {},
          
}
const quickbookLogin = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'LOGIN_QUICKBOOK':
    return { ...INITIAL_STATE, loginData: action.data }
  case 'LOGIN_QUICKBOOK_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  case 'LOGIN_CALLBACK_QUICKBOOK':
    return { ...INITIAL_STATE, loginCallbackData: action.data }
  case 'LOGIN_CALLBACK_QUICKBOOK_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
          
export default quickbookLogin;